export default "__VITE_ASSET__eI78dvP___"